import { GenIcon } from '../helpers/IconBase.es.js';

const UserProfileFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 20 20", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M10 10C12.7614 10 15 7.76142 15 5C15 2.23858 12.7614 0 10 0C7.23858 0 5 2.23858 5 5C5 7.76142 7.23858 10 10 10Z",
          fill: "black",
          fillOpacity: "0.65"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M10 11.6659C5.85977 11.6705 2.50461 15.0257 2.5 19.1659C2.5 19.6261 2.87309 19.9992 3.33332 19.9992H16.6666C17.1269 19.9992 17.5 19.6261 17.5 19.1659C17.4954 15.0257 14.1402 11.6705 10 11.6659Z",
          fill: "black",
          fillOpacity: "0.65"
        }
      }
    ]
  })(props);
};

export { UserProfileFilled };
